<template>
  <div class="list-group mt-2">
    <button
      :class="`list-group-item list-group-item-action ${hover === item[id] ? 'active' : ''}`"
      v-for="item in items"
      :key="item[id]"
      @mouseover="hover = item[id]" @mouseleave="hover = ''"
      @click.prevent="() => onClick(item)"
    >
      <slot :hover="hover === item[id]" :data="item" :columns="columns"></slot>
    </button>
    <div class="mt-2" v-if="items && items.length !== 0">
      <pagination-comp :pagination="pagination" :eventBusDataPaginationName="eventPagination"/>
    </div>
  </div>
</template>

<script>
import paginationComp from '@/components/pagination/PaginationComp'
import eventBus from '@/uteis/eventBus'

export default {
  components: {
    paginationComp
  },

  props: {
    eventData: { required: true, type: String },
    eventPagination: { required: true, type: String },
    onClick: { required: false, type: Function, default: () => console.log('') }
  },

  methods: {
    popularTable (values) {
      this.pagination = values.pagination
      this.id = values.id
      this.columns = values.columns
      this.items = values.data
    }
  },

  created () {
    eventBus.$on(this.eventData, (values) => {
      this.popularTable(values)
    })
  },

  data () {
    return {
      hover: '',
      id: '',
      dataTableChecked: [],
      items: [],
      columns: [],
      column: [],
      pagination: {
        hasPrev: false,
        hasNext: false,
        totalPage: 0
      }
    }
  }
}
</script>
